
import { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: 'A类是否有人帮做？',
    answer: 'A类零人工介入，校验不通过系统退回缺失字段，补齐后重提。',
  },
  {
    id: 2,
    question: '是否承诺放行/退税结果？',
    answer: '提交为工具直连提交+回执回传，不承诺放行结果。',
  },
  {
    id: 3,
    question: '单证保存多久？',
    answer: 'A类默认1个月；标准/尊享服务期内可保留可下载。',
  },
  {
    id: 4,
    question: '服务包是什么？',
    answer: '服务包为叠加项，不替代订阅费/免税费用。',
  },
];

export default function FAQAccordion() {
  // State holds the currently opened FAQ id (or null if none)
  const [openId, setOpenId] = useState<number | null>(null);

  // Toggle function with safety check
  const toggle = (id: number) => {
    // Ensure id is a valid number before toggling
    if (typeof id !== 'number' || isNaN(id)) {
      console.warn('Invalid FAQ id passed to toggle:', id);
      return;
    }
    setOpenId(prev => (prev === id ? null : id));
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-12">
          常见问题
        </h2>
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="text-base font-medium text-gray-800 pr-4">
                  {faq.question}
                </span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-xl text-gray-600 transition-transform duration-300 ${
                      openId === faq.id ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              {/* Answer panel with smooth height transition */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-40' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
